export default "__VITE_ASSET__DMoh_2dI__"